import React from 'react';
import { AboutHero } from '../components/sections/about/AboutHero';
import { FounderStory } from '../components/sections/about/FounderStory';
import { MissionValues } from '../components/sections/about/MissionValues';
import { AboutServices } from '../components/sections/about/AboutServices';
import { Credentials } from '../components/sections/about/Credentials';
import { AboutCta } from '../components/sections/about/AboutCta';
export function About() {
  return <>
      <AboutHero data-id="element-315" />
      <FounderStory data-id="element-316" />
      <MissionValues data-id="element-317" />
      <AboutServices data-id="element-318" />
      <Credentials data-id="element-319" />
      <AboutCta data-id="element-320" />
    </>;
}